import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FuseModule } from '@fuse/fuse.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseProgressBarModule, FuseSidebarModule, FuseThemeOptionsModule } from '@fuse/components';
import { fuseConfig } from 'app/fuse-config';
import { AppComponent } from 'app/app.component';
import { LayoutModule } from 'app/layout/layout.module';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { AlertComponent } from './main/apps/_components';
import { JwtInterceptor, ErrorInterceptor, DocManagerInterceptor } from './main/apps/_helpers';
import { AuthGuard } from './main/apps/_guards';
import { AuthenticationService } from './main/apps/_services';
import { ConfirmationDialogComponent } from 'app/main/apps/confirmation-dialog/confirmation-dialog.component';
import { ConfirmationDialogService } from 'app/main/apps/confirmation-dialog/confirmation-dialog.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LoaderComponent } from './main/apps/loader/loader.component';
import { LoaderService } from './main/apps/loader/loader.service';
import { LoaderInterceptor } from './interceptors/loader.interceptor';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { LoaderCustomService } from './main/apps/loaderCustom/loaderCustom.service';
import { LoaderCustomComponent } from './main/apps/loaderCustom/loaderCustom.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AngularFireModule } from "@angular/fire/compat";
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { environment } from 'environments/environment';
import { LoaderForComponentsService } from './main/apps/loaderForComponents/loaderForComponents.service';
import { LoaderCustomForComponent } from './main/apps/loaderForComponents/loaderForComponents.component';

const appRoutes: Routes = [
    {
        path: 'apps',
        loadChildren: () => import('./main/apps/apps.module').then(m => m.AppsModule)
    },
    {
        path: '**',
        redirectTo: 'apps/login'
    },
];

@NgModule({ declarations: [
        AppComponent,
        AlertComponent,
        ConfirmationDialogComponent,
        LoaderComponent,
        LoaderCustomComponent,
        LoaderCustomForComponent
    ],
    bootstrap: [
        AppComponent
    ],
    exports: [ConfirmationDialogComponent],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ], imports: [BrowserModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes, { useHash: true }),
        TranslateModule.forRoot(),
        // Fuse modules
        FuseModule.forRoot(fuseConfig),
        FuseProgressBarModule,
        FuseSharedModule,
        FuseSidebarModule,
        FuseThemeOptionsModule,
        // App modules
        FormsModule,
        LayoutModule,
        ReactiveFormsModule,
        MatProgressSpinnerModule,
        NgIdleKeepaliveModule.forRoot(),
        FontAwesomeModule,
        AngularFireModule.initializeApp(environment.firebaseConfig),
        AngularFirestoreModule], providers: [
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: DocManagerInterceptor, multi: true },
        AuthenticationService, AuthGuard,
        ConfirmationDialogService,
        LoaderService,
        LoaderCustomService,
        LoaderForComponentsService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {
}